/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-restricted-syntax */
/* eslint-disable prefer-destructuring */
/* eslint-disable react/jsx-props-no-spreading */
import queryString from "query-string";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Button } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";

import SearchIconWithPeople from "../../../assets/svg/SearchIconWithPeople";
import AppliedFilter from "../../../components/common/AppliedFilter/AppliedFilter";
import Loader from "../../../components/common/Loader/Loader";
import Modal from "../../../components/common/Modal/Modal";
import Pagination from "../../../components/common/new/Pagination/Pagination";
import PaginationForMobile from "../../../components/common/new/Pagination/PaginationForMobile";

import {
  AppliedFilterFriendLabelMap,
  DATES,
  EVENT_NAME,
  Constants,
} from "../../../contants";
import useParam from "../../../hooks/useParam";
import { SET_SELECTED_PENDING_TRANSFER_MEMBER } from "../../../redux/actionTypes/dashboard";
import { selectOSKeysByUserRole } from "../../../redux/selectors/user";
import { formDataToObject, isEmptyObj } from "../../../utils/helper";
import styles from "./TransferRequest.styles";
import InitiatorOrganizationSearch from "../../friend/FriendTransferRequest/InitiatorOrganizationSearch";
import TargetOrganizationSearch from "../../friend/FriendTransferRequest/targetOrganizationSearch";
import {
  getMemberFilters,
  getFormattedQuery,
  getMemberTransferRequestRoutePath,
  handleDependencyFilter,
  performOperation,
} from "../../friend/utils";
import Toast from "../../../components/common/Toast";
import PersonalDetailsSearch from "./PersonalDetailsSearch";
import TransferTable from "../../../components/common/new/AccordianTable/TransferTable";
import { ROUTES } from "../../../utils/constants";
import Member from "../../../services/api/member";

const LOADER_DELAY = 1000;
const PAGE = "page";

const filterOrder = [
  "initiatorAreaId",
  "initiatorClusterId",
  "initiatorZoneId",
  "initiatorRegionId",
  "initiatorChapterId",
  "initiatorDistrictId",
  "initiatorBlockId",
  "targetAreaId",
  "targetClusterId",
  "targetZoneId",
  "targetRegionId",
  "targetChapterId",
  "targetDistrictId",
  "targetBlockId",
];

function TransferRequest() {
  const TITLE = "Member Transfer Request - BSG";

  const [searchData, setSearchData] = useState([]);
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [openResultModal, setOpenResultModal] = useState(false);
  const [showSearchResult, setShowSearchResult] = useState(false);
  const allowModalRef = useRef(false);

  const formRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const metaData = useSelector((state) => state.meta);
  const disabledOSKeys = useSelector(selectOSKeysByUserRole);
  const { getQueryObject, getQueryParams, urlSearchParams } = useParam();

  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [size, setPageSize] = useState(Constants.DEFAULT_PAGE_SIZE);

  const [showToast, setShowToast] = useState(null);
  const isMobile = useMediaQuery("(max-width: 768px)");

  const clearFormRef = () => {
    if (!formRef.current) return;
    Object.keys(AppliedFilterFriendLabelMap).forEach((key) => {
      if (formRef.current[key]) {
        formRef.current[key].value = "";
        formRef.current[key]?.blur?.();
      }
    });
  };

  const resetFormState = () => {
    setSearchData([]);
    setAppliedFilters([]);
    clearFormRef();
  };

  const initializeFormState = (queryObject) => {
    if (!isEmptyObj(queryObject) && formRef.current) {
      clearFormRef();
      Object.keys(queryObject).forEach((key) => {
        if (formRef.current[key]) {
          formRef.current[key].value = queryObject[key];
        }
      });
    }
  };

  const updateSearchParam = (query) => {
    if (query?.length) {
      navigate(`/${getMemberTransferRequestRoutePath()}?${query}`);
    } else {
      navigate(`/${getMemberTransferRequestRoutePath()}`);
    }
  };

  const hasAnyRealFilter = (q) => {
    if (!q || isEmptyObj(q)) return false;
    return Object.entries(q).some(
      ([k, v]) =>
        !["page", "size"].includes(k) &&
        v !== undefined &&
        String(v).trim() !== ""
    );
  };

  const removeKeyFromQuery = (queryObject, filterKey) => {
    let updatedQuery = {
      ...queryObject,
      page: 0,
      size: Constants.DEFAULT_PAGE_SIZE,
    };

    if (DATES.includes(filterKey)) {
      delete updatedQuery[filterKey];
      delete updatedQuery[`${filterKey.split("From")[0]}To`];
    } else {
      delete updatedQuery[filterKey];
    }

    if (Object.keys(updatedQuery).length === 1 && PAGE in updatedQuery) {
      delete updatedQuery[PAGE];
    }

    // handle dependency filter
    updatedQuery = handleDependencyFilter(updatedQuery, disabledOSKeys || []);

    return updatedQuery;
  };

  const onRemoveFilter = (filterKey) => {
    let queryObject = getQueryObject();
    queryObject = removeKeyFromQuery(queryObject, filterKey);
    const updatedQuery = queryString.stringify(queryObject);
    updateSearchParam(updatedQuery);
    clearFormRef();

    if (!hasAnyRealFilter(queryObject)) {
      resetFormState();
      setOpenResultModal(false);
      setShowSearchResult(false);
      allowModalRef.current = false;
    }
  };

  const fetchSearchData = async (
    queryParams,
    page = 0,
    sizeParam = Constants.DEFAULT_PAGE_SIZE
  ) => {
    try {
      setIsLoading(true);
      const formattedQuery = getFormattedQuery({
        ...queryParams,
        page,
        size: sizeParam,
      });

      const { content, totalPages, totalElements, number } =
        await Member.getMemberPendingTransfer(formattedQuery);

      // Showing some delay to avoid loader flicker issue
      setTimeout(() => {
        setSearchData(content);
        setCurrentPage(number);
        setTotalPages(totalPages);
        setTotalElements(totalElements);
        setPageSize(sizeParam);
        setIsLoading(false);

        if (content.length > 0) {
          if (allowModalRef.current) {
            setOpenResultModal(true);
            setShowSearchResult(true);
            allowModalRef.current = false;
          }
        } else {
          if (allowModalRef.current) {
            setShowToast({ severity: "error", message: "No data found" });
          }
          setOpenResultModal(false);
          setShowSearchResult(false);
          allowModalRef.current = false;
        }
      }, LOADER_DELAY);
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();

    const rawFormData = new FormData(formRef.current);
    const formData = formDataToObject(rawFormData);

    const hasFilter = Object.values(formData).some(
      (val) => val && String(val).trim() !== ""
    );
    if (!hasFilter) {
      setShowToast({
        severity: "warning",
        message: "Please select your search filter",
      });
      return;
    }

    formData.page = 0;
    formData.size = Constants.DEFAULT_PAGE_SIZE;

    const query = queryString.stringify(formData);

    // Close all popover (kept to preserve behavior if any subcomponents use it)
    document.dispatchEvent(new Event(EVENT_NAME));
    allowModalRef.current = true;

    updateSearchParam(query);
    fetchSearchData(formData, formData.page, formData.size);
  };

  useEffect(() => {
    const queryObject = getQueryObject();
    if (isEmptyObj(queryObject)) {
      resetFormState();
      setOpenResultModal(false);
      setShowSearchResult(false);
      allowModalRef.current = false;
      return;
    }

    if (!hasAnyRealFilter(queryObject)) {
      resetFormState();
      setOpenResultModal(false);
      setShowSearchResult(false);
      allowModalRef.current = false;
      if (queryObject.page !== undefined || queryObject.size !== undefined) {
        updateSearchParam();
      }
      return;
    }

    const [query, params] = getQueryParams(queryObject);
    fetchSearchData(query, params.page, params.size);
    initializeFormState(query);
  }, [urlSearchParams.toString()]);

  useEffect(() => {
    const queryObject = getQueryObject();
    if (
      !isEmptyObj(queryObject) &&
      metaData &&
      disabledOSKeys &&
      hasAnyRealFilter(queryObject)
    ) {
      const query = getQueryParams(queryObject)[0];
      try {
        setAppliedFilters(getMemberFilters(query, metaData, disabledOSKeys));
      } catch (err) {
        console.error("Error in getMemberFilters:", err);
        setAppliedFilters([]);
      }
    } else {
      setAppliedFilters([]);
    }
  }, [metaData, disabledOSKeys, urlSearchParams.toString()]);

  const onPaginationClick = (clickedNumber) => {
    const queryObject = getQueryObject();
    const queryParams = queryString.stringify({
      ...queryObject,
      page: clickedNumber,
    });
    updateSearchParam(queryParams);
  };

  const onPageSizeClick = (operator) => {
    const queryObject = getQueryObject();
    const queryParams = queryString.stringify({
      ...queryObject,
      page: 0,
      size: queryObject.size
        ? performOperation(
            queryObject.size,
            Constants.DEFAULT_PAGE_SIZE,
            operator
          )
        : 2 * Constants.DEFAULT_PAGE_SIZE,
    });
    updateSearchParam(queryParams);
  };

  const handleForward = (payload) => {
    dispatch({
      type: SET_SELECTED_PENDING_TRANSFER_MEMBER,
      payload: { ...payload, id: payload.memberId },
    });
    navigate(`/${ROUTES.MEMBER_PENDING_TRANSFER.path}/forward`);
  };

  const handleReject = (payload) => {
    dispatch({
      type: SET_SELECTED_PENDING_TRANSFER_MEMBER,
      payload: { ...payload, id: payload.memberId },
    });
    navigate(`/${ROUTES.MEMBER_PENDING_TRANSFER.path}/reject`);
  };

  const handleRemarks = (payload) => {
    dispatch({
      type: SET_SELECTED_PENDING_TRANSFER_MEMBER,
      payload: { ...payload, id: payload.transferId },
    });
    navigate(`/remarks/member/${payload.transferId}`);
  };

  const handleAccept = (payload) => {
    dispatch({
      type: SET_SELECTED_PENDING_TRANSFER_MEMBER,
      payload: { ...payload, id: payload.memberId },
    });
    navigate(`/${ROUTES.MEMBER_PENDING_TRANSFER.path}/accept`);
  };

  const handleCancel = async (selectedMember) => {
    try {
      setIsLoading(true);
      await Member.cancelMember({
        id: selectedMember.transferId,
        memberId: selectedMember.memberId,
      });
      setIsLoading(false);
      setShowToast({ message: "Cancel Successfully", severity: "success" });
      updateSearchParam();
      fetchSearchData();
    } catch (error) {
      setIsLoading(false);
      setShowToast({ message: error.message, severity: "error" });
    }
  };

  const onRefresh = () => {
    const queryObject = getQueryObject();
    const [query, params] = getQueryParams(queryObject);
    fetchSearchData(query, params.page, params.size);
  };

  const handleGoBackToSearch = () => {
    setOpenResultModal(false);
    setShowSearchResult(false);
    allowModalRef.current = false;
  };

  const handleResetAndClose = () => {
    resetFormState();
    updateSearchParam();
    setShowSearchResult(false);
    setOpenResultModal(false);
    allowModalRef.current = false;
  };

  const orderedFilters = filterOrder
    .map((filterKey) =>
      appliedFilters.find((filter) => filter.key === filterKey)
    )
    .filter(Boolean);
  const additionalFilters = appliedFilters.filter(
    (filter) => !filterOrder.includes(filter.key)
  );

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>

      <div style={styles.container}>
        {/* Top-right Clear Filters (like 1st code) */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "1px",
          }}
        >
          <Button
            onClick={handleResetAndClose}
            variant="outlined"
            color="secondary"
            sx={{
              textTransform: "none",
              height: "20px",
              fontSize: "13px",
              fontWeight: "600",
              marginRight: "10px",
              width: "85px",
              padding: "0px !important",
            }}
          >
            Clear Filters
          </Button>
        </div>

        {/* Filters rendered directly on the page (no popovers) */}
        <div style={styles.filter}>
          <form
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              width: "100%",
            }}
            onSubmit={onSubmit}
            ref={formRef}
          >
            <div>
              <div style={{ fontWeight: 600, marginBottom: "8px" }}>
                Organization Structure From
              </div>
              <InitiatorOrganizationSearch
                formRef={formRef}
                disabledOSKeys={disabledOSKeys}
              />
            </div>

            <div>
              <div style={{ fontWeight: 600, marginBottom: "8px" }}>
                Organization Structure To
              </div>
              <TargetOrganizationSearch
                formRef={formRef}
                disabledOSKeys={disabledOSKeys}
              />
            </div>

            <div>
              <div style={{ fontWeight: 600, marginBottom: "8px" }}>
                Personal Details
              </div>
              <PersonalDetailsSearch
                formRef={formRef}
                disabledOSKeys={disabledOSKeys}
              />
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: isMobile ? "center" : "flex-end",
                paddingTop: isMobile ? "10px" : "10px",
                marginRight: isMobile ? "15px" : "10px",
                paddingBottom: isMobile ? "100px" : "0px",
              }}
            >
              <Button
                type="submit"
                variant="contained"
                color="primary"
                sx={{
                  width: isMobile ? "90%" : "auto",
                }}
              >
                Search
              </Button>
            </div>
          </form>
        </div>
        {/* Mobile separator border - visual boundary */}
        {isMobile && (
          <div
            style={{
              borderTop: "2px solid #ffffffff",
              paddingTop: "15px",
              paddingBottom: "30px",
              marginTop: "10px",
            }}
          />
        )}

        {isLoading && <Loader />}

        {/* Results in a full-width modal (like 1st code) */}
        <Modal
          open={openResultModal}
          onClose={handleGoBackToSearch}
          title="Search Results"
          customStyle={{
            marginTop: "30px",
            width: "98%",
            maxWidth: "100%",
            height: "90%",
            maxHeight: "100%",
            overflowY: "auto",
            backgroundColor: "#fff",
            display: "flex",
            flexDirection: "column",
            padding: "0px 10px 2px 10px",
            position: "relative",
          }}
        >
          {isLoading ? (
            <Loader />
          ) : searchData.length > 0 ? (
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                  gap: "10px",
                  fontWeight: 600,
                  fontSize: 13,
                  marginBottom: "0px",
                  paddingBottom: "0px",
                  borderBottom: "1px solid #eee",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flex: 1,
                    minWidth: 260,
                    gap: 10,
                    alignItems: "center",
                    flexWrap: "wrap",
                  }}
                >
                  <div style={{ flex: "0 0 auto" }}>Total: {totalElements}</div>
                  {appliedFilters.length > 0 && (
                    <div style={{ flex: 1, minWidth: 200 }}>
                      <div style={styles.filterWrapper}>
                        <div style={styles.filterContainer}>
                          {orderedFilters.map((filter) => (
                            <AppliedFilter
                              key={filter.key}
                              filter={filter}
                              onRemove={onRemoveFilter}
                            />
                          ))}
                          {additionalFilters.map((filter) => (
                            <AppliedFilter
                              key={filter.key}
                              filter={filter}
                              onRemove={onRemoveFilter}
                            />
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    flexWrap: "wrap",
                    flex: "0 0 auto",
                  }}
                >
                  <Button
                    onClick={handleResetAndClose}
                    variant="outlined"
                    color="secondary"
                    sx={{
                      textTransform: "none",
                      height: "32px",
                      fontSize: "13px",
                      padding: "0 14px",
                      minWidth: "100px",
                    }}
                  >
                    Clear Filters
                  </Button>
                  <Button
                    onClick={handleGoBackToSearch}
                    variant="contained"
                    color="primary"
                    sx={{
                      textTransform: "none",
                      height: "32px",
                      fontSize: "13px",
                      padding: "0 14px",
                    }}
                  >
                    Back
                  </Button>
                </div>
              </div>

              <div style={{ flex: 1, overflowX: "auto", marginTop: "15px" }}>
                <TransferTable
                  data={searchData || []}
                  handleForward={handleForward}
                  handleReject={handleReject}
                  handleRemarks={handleRemarks}
                  handleCancel={handleCancel}
                  handleAccept={handleAccept}
                  cameFromMemberTransfer
                  onRefresh={onRefresh}
                />
              </div>
              <div style={{ marginTop: "20px" }}>
                {isMobile ? (
                  <PaginationForMobile
                    totalPages={totalPages}
                    totalResults={totalElements}
                    currentPage={currentPage}
                    pageSize={size}
                    onChange={onPaginationClick}
                    onPageSizeClick={onPageSizeClick}
                  />
                ) : (
                  <Pagination
                    totalPages={totalPages}
                    totalResults={totalElements}
                    currentPage={currentPage}
                    pageSize={size}
                    onChange={onPaginationClick}
                    onPageSizeClick={onPageSizeClick}
                  />
                )}
              </div>
            </>
          ) : showSearchResult ? null : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                padding: "30px 0",
                color: "#777",
              }}
            >
              <SearchIconWithPeople width={100} />
              <p>Choose your Search Filter</p>
            </div>
          )}
        </Modal>

        <Toast
          open={!!showToast}
          severity={showToast?.severity || ""}
          message={showToast?.message || ""}
          handleClose={() => setShowToast(null)}
        />
      </div>
    </>
  );
}

export default TransferRequest;
